<template>
  <div class="offer-list-container">
    <div class="header-image">
      <img v-if="hasBannerImage" class="banner-image" :src="imagePath" alt="Imagem de cabeçalho" />
    </div>
    <div class="search-section">
      <div class="search-input">
        <mf-icon small fill>search</mf-icon>
        <span class="placeholder">Buscar produto na campanha</span>
        <mf-icon small fill>mic</mf-icon>
      </div>
    </div>
    <div class="display-title-section">
      <div class="display-title">
        <span>{{ displayTitle }}</span>
      </div>
    </div>
    <div class="products-section d-flex flex-row justify-space-between">
      <div v-for="(product, index) in products" :key="product.image" class="product-item">
        <product-card
          variant="basic-chip"
          chip-color="#00B395"
          :product-image-src="`highlight-products-images/product-${product.image}.png`"
          chip-label="Desconto"
          rule-chip-label="Máximo x por CPF *"
          :discount-label="product.discountLabel"
          :discount-number="product.discountNumber"
          :price="0"
          :product-name="`Produto exemplo ${index + 1}`"
          product-measure="Unidade"
          product-description="Válido até 08/10 ou enquanto houver estoque"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'OfferList',
  components: {
    ProductCard: () => import('../ProductCard.vue'),
  },
  mixins: [highlightOffer],
  data: () => ({
    products: [
      {
        discountLabel: '- 15%',
        image: 'strawberry',
        discountNumber: 4.5,
      },
      {
        discountLabel: 'Leve 15 e Pague 14',
        image: 'crunch',
        discountNumber: 0,
      },
      {
        discountLabel: '- 15%',
        image: 'bud',
        discountNumber: 4.5,
      },
      {
        discountLabel: 'Leve 15 e Pague 14',
        image: 'coca',
        discountNumber: 0,
      },
    ],
  }),
  computed: {
    hasBannerImage() {
      return this.highlightBannerImage?.length > 0 || this.isExpandedModel
    },
    imagePath() {
      const url = this.highlightBannerImage
      return url || require('@/assets/app-default-banner.jpg')
    },
    displayTitle() {
      return this.highlightDisplayTitle || 'Título de exibição'
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.offer-list-container {
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .header-image {
    .banner-image {
      width: 100%;
      height: 180px;
      object-fit: cover;
    }
  }
  .products-section {
    flex-wrap: wrap;
    padding: 0 23px 0 23px;
    gap: 24px;
    .product-item {
      max-width: 150px;
    }
  }
  .search-section {
    padding: 0px 16px 8px 16px;
    height: 36px;
    .search-input {
      background-color: white;
      border-radius: 20px;
      border: 1px solid #e2e8f0;
      box-shadow: 0px 1px 8px -4px rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      padding: 10px 16px;
      max-height: 100%;
      .placeholder {
        color: #4a5568;
        font-family: Poppins;
        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: normal;
        width: 100%;
        margin-left: 8px;
      }
    }
  }
  .display-title-section {
    width: 100%;
    border-bottom: 1px solid #d3d3d3;
    overflow: hidden;
    .display-title {
      margin-left: 16px;
      span {
        padding: 0px 24px;
        border-bottom: 2px solid #3d3d3d;
        color: #3d3d3d;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 133%;
      }
    }
  }
}
</style>
